import { useShallow } from 'zustand/react/shallow';
import { createBase, createSelectors } from './base';

// 1.初始状态
// define the initial state
const initialState = {
  hello: null,
  doNotModify: 'gogogo',
};

// 2.定义基础store
const useExampleStoreBase = createBase(
  (set, get) => ({
    ...initialState,
      // undefined和'example/setName'主要用于redux devtools友好展示
      setName: (name) => set((state) => { state.hello = name }, undefined, 'example/setName'),
      reset: () => set((state) => { state = initialState }    , undefined, 'example/reset'),
    }),
  {
      // 每个store唯一名称
      name: 'example-storage',
    },
)

// 3. 自动生成selector
export const useExampleStore = createSelectors(useExampleStoreBase);
export default useExampleStore;

// 在组件中的用法
// get the property
//const hello = useExampleStore.use.bears();
// get the action
//const setName = useExampleStore.use.setName();
//const reset = useExampleStore.use.();

// 防止相同值rerender
// Object pick, re-renders the component when either state.nuts or state.honey change
// const { hello } = useExampleStore(
//   useShallow((state) => ({ hello: state.hello})),
// )